const initialState = { themePrimaryColor: localStorage.getItem("themePrimaryColor") || "1677ff" }
export const themeReducer = (prevState = initialState, action) => {
    let newState = { ...prevState }
    if (action.type === "setThemePrimaryColor") {
        newState.themePrimaryColor = action.data
        localStorage.setItem("themePrimaryColor", action.data)
    }
    return newState
}